import { Trans as _Trans } from "../lib/i18n/Trans";
import { useLingui as _useLingui } from "../lib/i18n/useLingui";
import { formatNumber, useFormatLocale } from "../lib/i18n/format";
import { cn } from "../lib/utils";
import React from "react";
const LOADING_DOT_DELAY_CLASS_NAMES = ["[animation-delay:0ms]", "[animation-delay:250ms]", "[animation-delay:500ms]"];
const CONTROL_CLASS_NAME = cn("text-xs font-medium", "transition-colors duration-200", "text-primary-400 hover:text-foreground disabled:hover:text-primary-400");
export function LoadMore({
  showDetails = true,
  rowCount,
  totalRowCount,
  totalRowCountIsCapped = false,
  isLoading = false,
  onLoadMore,
  onShowLess,
  label,
  loadingLabel,
  showLessLabel
}) {
  const {
    _: _t
  } = _useLingui();
  const formatLocale = useFormatLocale();
  // Plural forms are picked with the counts, but `#` would format them in the catalog's locale.
  const formattedRowCount = formatNumber(rowCount, undefined, formatLocale);
  const formattedTotalRowCount = totalRowCount === undefined ? undefined : formatNumber(totalRowCount, undefined, formatLocale);
  // When the total is known and everything is loaded, there is nothing left to
  // fetch: keep the details, hide the control (same behavior as Pagination).
  const loadMoreIsHidden = totalRowCount !== undefined && !totalRowCountIsCapped && rowCount >= totalRowCount;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cn(CONTROL_CLASS_NAME, loadMoreIsHidden && "hidden"),
    onClick: onLoadMore,
    disabled: isLoading || loadMoreIsHidden
  }, isLoading ? /*#__PURE__*/React.createElement("span", null, loadingLabel !== null && loadingLabel !== void 0 ? loadingLabel : _t(
  /** i18n */
  {
    id: "yQE2r9",
    message: "Loading"
  }), LOADING_DOT_DELAY_CLASS_NAMES.map(delayClassName => /*#__PURE__*/React.createElement("span", {
    key: delayClassName,
    className: cn("animate-loading-dot opacity-100 motion-reduce:animate-none", delayClassName)
  }, "."))) : label !== null && label !== void 0 ? label : _t(
  /** i18n */
  {
    id: "yQ2kGp",
    message: "Load more"
  })), onShowLess && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: CONTROL_CLASS_NAME,
    onClick: onShowLess,
    disabled: isLoading
  }, showLessLabel !== null && showLessLabel !== void 0 ? showLessLabel : _t(
  /** i18n */
  {
    id: "6lGV3K",
    message: "Show less"
  }))), /*#__PURE__*/React.createElement("span", {
    className: cn("text-xs", "text-muted-foreground", showDetails ? "visible" : "collapse")
  }, totalRowCount === undefined ? /*#__PURE__*/React.createElement(_Trans,
  /** i18n */
  {
    id: "nglAwy",
    message: "{rowCount, plural, one {{formattedRowCount} item} other {{formattedRowCount} items}}",
    values: {
      rowCount: rowCount,
      formattedRowCount: formattedRowCount
    }
  }) : totalRowCountIsCapped ? /*#__PURE__*/React.createElement(_Trans,
  /** i18n */
  {
    id: "MknF08",
    message: "Showing {formattedRowCount} of {totalRowCount, plural, one {{formattedTotalRowCount}+ item} other {{formattedTotalRowCount}+ items}}",
    values: {
      formattedRowCount: formattedRowCount,
      totalRowCount: totalRowCount,
      formattedTotalRowCount: formattedTotalRowCount
    }
  }) : /*#__PURE__*/React.createElement(_Trans,
  /** i18n */
  {
    id: "nIcbuA",
    message: "Showing {formattedRowCount} of {totalRowCount, plural, one {{formattedTotalRowCount} item} other {{formattedTotalRowCount} items}}",
    values: {
      formattedRowCount: formattedRowCount,
      totalRowCount: totalRowCount,
      formattedTotalRowCount: formattedTotalRowCount
    }
  })));
}
//# sourceMappingURL=LoadMore.js.map